import IndexPage from 'components/Pages/IndexPage';
import getStaticProps from 'components/Pages/props/indexPageGetStaticProps';

export default IndexPage;

export { getStaticProps };
